/**
 * Phase F — Selection store extension (pre-breakfast only).
 *
 * Local-only client state. Cleared automatically when breakfast starts
 * or when reset fires.
 */
import { create } from "zustand";

const useSelectionStore = create((set, get) => ({
  selectedCodes: [], // string[] of table.code

  toggle: (code) => {
    const cur = get().selectedCodes;
    if (cur.includes(code)) {
      set({ selectedCodes: cur.filter((c) => c !== code) });
    } else {
      set({ selectedCodes: [...cur, code] });
    }
  },

  clear: () => set({ selectedCodes: [] }),

  isSelected: (code) => get().selectedCodes.includes(code),
}));

export default useSelectionStore;
